import ClearIcon from '@mui/icons-material/Clear';
import DoneIcon from '@mui/icons-material/Done';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Button, Chip, Container, IconButton, Modal, Paper, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function Finding({ finding, handleSelect, handleDelete }) {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleDeleteConfirm = () => {
    handleDelete(finding.id);
    handleCloseModal();
  };

  return (
    <>
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Container variant="modal" disableGutters sx={{ width: '600px' }}>
          <Stack variant="modalTop" spacing={2}>
            <Typography variant="h6">{t('finding.delete.modalTitle')}</Typography>
            <Typography>{t('finding.delete.modalDescription')}</Typography>
          </Stack>
          <Stack variant="modalButtons" direction="row" justifyContent="flex-end" spacing={1}>
            <Button id='cancel' variant="text" startIcon={<ClearIcon />} onClick={handleCloseModal}>
              {t('finding.delete.modalCancel')}
            </Button>
            <Button id='delete-finding' variant="contained" startIcon={<DoneIcon />} onClick={() => handleDeleteConfirm()}>
              {t('finding.delete.modalAccept')}
            </Button>
          </Stack>
        </Container>
      </Modal>
      <Paper variant="elevation" subtype="finding">
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography>{finding.title}</Typography>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Chip
              variant="filled"
              size="small"
              subtype={finding.criticality}
              label={t(`finding.criticality.${finding.criticality}`)}
            />
            <Stack direction="row">
              <IconButton id={`${finding.title}-delete`} size="small" onClick={() => handleOpenModal()}>
                <DeleteOutlineIcon />
              </IconButton>
              <IconButton id={`${finding.title}-edit`} size="small" onClick={() => handleSelect(finding.id)}>
                <EditOutlinedIcon />
              </IconButton>
            </Stack>
          </Stack>
        </Stack>
      </Paper>
    </>
  );
}

export default Finding;
